// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const TransactionLineType = {
  Product: {
    Name: 'Product',
    Value: 'product',
    Label: 'Product',
    Icon: 'Flower2',
  },
  Tip: {
    Name: 'Tip',
    Value: 'tip',
    Label: 'Tip',
    Icon: 'HandCoins',
  },
  RelayFee: {
    Name: 'Relay Fee',
    Value: 'relay_fee',
    Label: 'Relay Fee',
    Icon: 'HandCoins',
  },
  VariableServiceFee: {
    Name: 'Variable Service Fee',
    Value: 'variable_service_fee',
    Label: 'Service Fee',
    Icon: 'HandCoins',
  },
  FloristFee: {
    Name: 'Florist Fee',
    Value: 'florist_fee',
    Label: 'Florist Fee',
    Icon: 'HandCoins',
  },
  Tax: {
    Name: 'Tax',
    Value: 'tax',
    Label: 'Tax',
    Icon: 'HandCoins',
  },
  MerchantFee: {
    Name: 'Merchant Fee',
    Value: 'merchant_fee',
    Label: 'Merchant Fee',
    Icon: 'HandCoins',
  },
  PlatformFee: {
    Name: 'Platform Fee',
    Value: 'platform_fee',
    Label: 'Platform Fee',
    Icon: 'HandCoins',
  },
  PosFee: {
    Name: 'Pos Fee',
    Value: 'pos_fee',
    Label: 'Pos Fee',
    Icon: 'HandCoins',
  },
  Delivery: {
    Name: 'Delivery',
    Value: 'delivery',
    Label: 'Delivery',
    Icon: 'Truck',
  },
  Shipping: {
    Name: 'Shipping',
    Value: 'shipping',
    Label: 'Shipping',
    Icon: 'Package',
  },
  Discount: {
    Name: 'Discount',
    Value: 'discount',
    Label: 'Discount',
    Icon: 'TagIcon',
  },
  PaymentApplied: {
    Name: 'Payment Applied',
    Value: 'payment_applied',
    Label: 'Payment Applied',
    Icon: 'BanknoteArrowUp',
  },
} as const

export type TransactionLineTypeValue =
  (typeof TransactionLineType)[keyof typeof TransactionLineType]['Value']
